<template>
    <Section width="lg" class="latest-reviews">
        <div 
            v-if="$validateText(slice.primary.text)"
            class="rich-text primary-text"
            v-html="$prismic.asHtml(slice.primary.text)"
        />
        <div class="review-wrapper">
            <latest-review 
                v-for="review in latestReviews" 
                :key="review.id"
                :review="review"    
            />
        </div>
    </Section>
</template>

<script>
import LatestReview from '@/components/LatestReview.vue';
export default {
    components: {
        LatestReview
    },
    props: {
        slice: {
            type: Object,
            required: true
        }
    },
    computed: {
        latestReviews() {
            return this.$store.state.latestCardReviews;
        }
    }
};
</script>
<style lang="scss" scoped>
    .latest-reviews {
        .primary-text {
            @include spacing(margin, 6, bottom);
        }
        .review-wrapper {
            display: grid;
            grid-template-columns: repeat(1, 1fr);
            gap: 1rem;
            @include device(pad) {
                grid-template-columns: repeat(2, 1fr);
            }
            @include device(desktop) {
                grid-template-columns: repeat(3, 1fr);
            }
        }
    }
</style>